<template>
  <div class="privacy">
    <div class="privacy-wrapper">
      <h2 class="privacy-title">Shipping policy</h2>
      <h2 class="privacy-title">运输政策</h2>
      <br />
      <h2 class="sTitle">1. Shipping Conditions</h2>
      <h2 class="sTitle">一、运输条件</h2>

      <p class="s1">
        We provide small parcel shipping agency services between Mainland China and
        international destinations. All shipping arrangements and operations shall comply
        with the export regulations of Mainland China, the laws of the Hong Kong Special
        Administrative Region (where transshipment through Hong Kong occurs), and the
        import requirements of the destination country.
        <br /><br />本司提供中国大陆与国际之间的小包代理运输服务。所有运输安排及操作均遵守中国大陆出口法规、香港特别行政区相关法律（如经香港中转）及目的地国家的进口要求。
      </p>

      <h2 class="sTitle">1.1 Shipping Methods</h2>
      <h2 class="sTitle">运输方式</h2>

      <p class="s1">
        Shipping methods include but are not limited to international air freight,
        international ocean freight, land transportation, and multimodal transport. We
        reserve the right to select reasonable shipping routes and carrier channels based
        on actual customs clearance conditions and logistics arrangements.
        <br /><br />运输方式包括但不限于国际空运、国际海运、陆路运输及多式联运。本司有权根据实际通关条件和物流安排，合理选择运输路线及承运渠道。
      </p>

      <h2 class="sTitle">1.2 Shipping Arrangements</h2>
      <h2 class="sTitle">运输安排</h2>

      <p class="s1">
        Shipments shall be arranged according to operational schedules after the goods
        arrive at the designated warehouse or consolidation point. We shall not be liable
        for any interruption or adjustment of shipping caused by uncontrollable factors
        such as customs inspections, policy changes in the destination country,
        flight/vessel schedule changes, weather, pandemics, war, or similar events.
        <br /><br />货物抵达指定仓库或集货点后，由本司根据作业排期安排出运。因海关查验、目的国政策调整、航班/船期变动、天气、疫情、战争等不可控因素导致的运输中断或调整，本司不承担相关责任。
      </p>

      <h2 class="sTitle">1.3 Customs Clearance Responsibility</h2>
      <h2 class="sTitle">清关责任</h2>

      <p class="s1">
        Customers must ensure that the cargo content is declared truthfully and
        completely, and provide accurate declaration information in both Chinese and
        English.
        <br /><br />客户须确保货物内容真实、完整申报，并提供准确的中英文申报信息。
      </p>

      <h2 class="sTitle">Special Notes:</h2>
      <h2 class="sTitle">特别提示：</h2>

      <p class="s1">
        Export of goods must comply with the customs supervision requirements of Mainland
        China. False or under-declaration is strictly prohibited.
        <br /><br />货物出口须符合中国海关监管要求，严禁伪报、瞒报。
      </p>

      <p class="s1">
        If the shipment contains wooden packaging (e.g., pallets, wooden boxes), such
        packaging must bear an IPPC (International Plant Protection Convention) mark or
        valid phytosanitary treatment certification.
        <br /><br />如货物含有木质包装（如托盘、木箱），须具有国际植物保护公约（IPPC）标识或有效除害处理证明。
      </p>

      <p class="s1">
        Customers shall independently confirm the import restrictions and quarantine
        requirements of the destination country. We shall not be liable for any detention,
        return, or destruction of goods by the customs authorities of the destination
        country.
        <br /><br />客户应自行确认目的国的进口限制及检疫要求，本司不对目的国海关扣留、退运或销毁承担责任。
      </p>

      <h2 class="sTitle">2. Packaging Conditions</h2>
      <h2 class="sTitle">二、包装条件</h2>
      <br />
      <h2 class="sTitle">2.1 Basic Packaging Requirements</h2>
      <h2 class="sTitle">基本包装要求</h2>

      <p class="s1">
        Packaging must be strong, intact, and tightly sealed, capable of withstanding
        normal handling, compression, and climatic variations in the international
        shipping environment. Naked shipments or packaging made of inferior, damaged, or
        contaminated materials are not accepted.
        <br /><br />包装应坚固、完好、封口严密，能够承受国际运输环境下的正常搬运、挤压及气候变化。不接受裸装或使用劣质、破损、受污染的包装材料。
      </p>

      <h2 class="sTitle">2.2 Fragile and Special Items</h2>
      <h2 class="sTitle">易碎及特殊物品</h2>

      <p class="s1">
        Fragile, pressure-sensitive, or precision instruments must be packaged in rigid
        outer containers with sufficient cushioning material inside (e.g., bubble wrap,
        foam, expanded polyethylene). The outer packaging must display internationally
        recognized labels such as "Fragile," "This Way Up," or "Do Not Crush."
        <br /><br />易碎、怕压、精密仪器等货物须使用硬质外包装，内部填充足够的缓冲材料（如气泡膜、珍珠棉、泡沫），外包装规范粘贴“易碎”“向上”“怕压”等国际通用标识。
      </p>

      <h2 class="sTitle">2.3 Packaging Cleanliness and Hygiene</h2>
      <h2 class="sTitle">包装清洁与卫生</h2>

      <p class="s1">
        Outer packaging shall remain clean, dry, free from odor and leakage, and comply
        with the quarantine and public health requirements of Mainland China and the
        destination country. Packaging bearing dangerous goods markings, politically
        sensitive markings, or misleading labels is prohibited.
        <br /><br />外包装应保持清洁、干燥、无异味、无泄漏，符合中国及目的国检疫与公共卫生要求。不得使用带有危险品标识、政治敏感标识或误导性标识的包装。
      </p>

      <h2 class="sTitle">3. Prohibited Items and Liability for Violations</h2>
      <h2 class="sTitle">三、禁运与违规责任</h2>
      <br />
      <h2 class="sTitle">3.1 Prohibited Items</h2>
      <h2 class="sTitle">严禁运输</h2>

      <p class="s1">
        Dangerous goods (as defined by IATA/IMDG codes), illicit substances, drugs,
        firearms and ammunition, flammable and explosive materials, corrosive substances,
        radioactive materials, live animals and perishable goods, currency, negotiable
        securities, gold and silver jewelry, state cultural relics, and any other items
        prohibited by law.
        <br /><br />危险品（按IATA/IMDG规则）、违禁品、毒品、枪支弹药、易燃易爆品、腐蚀品、放射性物质、鲜活易腐物品、货币、有价证券、金银珠宝、国家文物及法律禁止运输的其他物品。
      </p>

      <h2 class="sTitle">3.2 Consequences of Violation</h2>
      <h2 class="sTitle">违规后果</h2>

      <p class="s1">
        Any legal liability, customs fines, loss of goods, return costs, and third-party
        claims arising from the customer's concealment, misdeclaration, non-compliant
        packaging, or provision of false declaration information shall be borne entirely
        by the consignor (customer).
        <br /><br />因客户瞒报、谎报、包装不合规或提供虚假申报信息导致的一切法律责任、海关罚款、货物损失、退运费用及第三方索赔，由托运人（客户）全额承担。
      </p>

      <h2 class="sTitle">4. Documentation and Labeling</h2>
      <h2 class="sTitle">四、文件与标识</h2>

      <p class="s1">
        Each parcel must bear a clearly visible and scannable tracking number and barcode
        (or international waybill).
        <br /><br />每个包裹外须粘贴清晰、可扫描的运单号及条形码（或国际运单）。
      </p>

      <p class="s1">
        If shipment is destined for a designated overseas warehouse or requires a specific
        customs clearance channel, labels, customs declaration forms, or copies of
        commercial invoices must be affixed as required, and the information must be
        consistent with the accompanying shipping documents.
        <br /><br />如需发往指定海外仓库或通过特定清关渠道，须按要求粘贴唛头、海关申报单或商业发票副本，内容与实际托运单证一致。
      </p>

      <h2 class="sTitle">GOVERNING LAW</h2>
      <h2 class="sTitle">法律适用</h2>
      <p class="s1">
        These Terms of Service and any separate agreements whereby we provide you Services
        shall be governed by and construed in accordance with the laws of Hong Kong.
        <br /><br />本服务条款及我们向您提供服务的任何单独协议，均受香港法律管辖并据其解释。
      </p>
    </div>
  </div>
</template>
<script>
import { Button } from "vant";

import Vue from "vue";
Vue.use(Button);
export default {
  name: "Privacy",
  data() {
    return {};
  },
  created() {
    const { headerHide } = this.$route.query;
    if (headerHide) {
      this.headerHide = JSON.parse(headerHide);
      if (this.headerHide) {
        document.getElementsByClassName("van-nav-bar")[0].style.display = "none";
      }
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.privacy {
  * {
    font-size: 11px;
  }
  .privacy-wrapper {
    width: 90%;
    margin: auto;
    padding-top: 15px;
    .privacy-title {
      width: 100%;
      text-align: center;
      font-size: 13px;
      margin-top: 5%;
    }
    .titleInfo {
      width: 100%;
      text-align: center;
      margin: 10px 0;
    }
    .info {
      width: 100%;
      text-align: center;
      margin: 25px 0;
    }
    .s1 {
      text-align: left;
      margin: 25px 0;
    }
    .sTitle {
      text-align: left;
      margin-top: 10px;
      margin-bottom: 0px;
    }
    .s2 {
      font-size: 12px;
      text-align: left;
      margin: 25px 0;
    }
    .s2Title {
      font-size: 12px;
      text-align: left;
      margin-top: 10px;
      margin-bottom: 0px;
    }
    .link-button {
      vertical-align: middle;
      margin-left: 2%;
      margin-bottom: 1%;
      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
    }
    .high-light {
      font-weight: bold;
      color: #1d86f7;
    }
  }
}
</style>
